var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnefifty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 56,
    viewBox: "0 0 71 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.855 18.422a7.014 7.014 0 1 1 14.028 0 7.014 7.014 0 0 1-14.028 0zm7.015-4.05a4.05 4.05 0 1 0 0 8.1 4.05 4.05 0 0 0 0-8.1zM45.578 20.268a5.174 5.174 0 1 1 10.349 0 5.174 5.174 0 0 1-10.349 0zm5.175-2.21a2.211 2.211 0 1 0 0 4.422 2.211 2.211 0 0 0 0-4.423zM15.317 16.61a5.175 5.175 0 1 1 7.32 7.318 5.175 5.175 0 0 1-7.32-7.319zm2.096 2.095a2.211 2.211 0 1 0 3.127 3.127 2.211 2.211 0 0 0-3.127-3.127z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.892 19.517a3.736 3.736 0 1 1 5.284 5.284 3.736 3.736 0 0 1-5.284-5.284zm1.59 1.59a1.489 1.489 0 1 0 2.105 2.105 1.489 1.489 0 0 0-2.106-2.106zM67.108 19.517a3.736 3.736 0 1 0-5.284 5.284 3.736 3.736 0 0 0 5.284-5.284zm-1.59 1.59a1.489 1.489 0 1 1-2.104 2.104 1.489 1.489 0 0 1 2.105-2.105z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.365
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.466 48.311a5.905 5.905 0 0 0 2.453-.307c.246.97.587 1.903 1.009 2.788a8.868 8.868 0 0 1-11.821-8.365v-9.234a3.329 3.329 0 0 1 3.329-3.328h7.772a7.714 7.714 0 0 0-.742 2.964H13.07v9.598a5.904 5.904 0 0 0 5.396 5.884z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.73
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.178 41.918a4.1 4.1 0 0 0 1.781-.241c.181.738.44 1.446.765 2.114a6.349 6.349 0 0 1-8.542-5.96V31.3a2.43 2.43 0 0 1 2.43-2.43h5.62a5.381 5.381 0 0 0-.574 2.248H2.43v6.713a4.101 4.101 0 0 0 3.748 4.087zM64.822 41.918a4.101 4.101 0 0 1-1.781-.241c-.181.738-.44 1.446-.765 2.114a6.349 6.349 0 0 0 8.542-5.96V31.3a2.43 2.43 0 0 0-2.43-2.43h-5.62c.352.698.548 1.465.574 2.248H68.57v6.713a4.101 4.101 0 0 1-3.748 4.087z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.365
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.68 51.25a8.866 8.866 0 0 1-3.882-.458c.422-.886.76-1.819 1.008-2.788a5.904 5.904 0 0 0 7.85-5.577v-9.598H49.26a7.704 7.704 0 0 0-.743-2.964h7.773a3.329 3.329 0 0 1 3.329 3.328v9.234a8.868 8.868 0 0 1-7.94 8.822zM27.479 32.829h-.365v11.444a7.751 7.751 0 0 0 15.503 0V32.83H27.478zm-2.354-1.99a3.329 3.329 0 0 1 2.354-.974h14.773a3.328 3.328 0 0 1 3.328 3.328v11.08a10.715 10.715 0 0 1-21.43 0v-11.08c0-.882.35-1.73.975-2.353z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.73
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.274 7.138c.61 0 1.105-.494 1.105-1.105V1.105a1.105 1.105 0 1 0-2.21 0v4.928c0 .61.495 1.105 1.105 1.105zM27.178 6.206a1.101 1.101 0 0 0 1.563-.001 1.105 1.105 0 0 0-.002-1.563L24.713.624a1.105 1.105 0 1 0-1.561 1.564l4.026 4.018zM42.588 6.53c.282 0 .565-.109.78-.324l4.024-4.019A1.105 1.105 0 0 0 45.83.624l-4.023 4.018a1.105 1.105 0 0 0 .78 1.887z",
    fill: "#88A13B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnefifty);
export default __webpack_public_path__ + "static/media/onefifty.7a1561ae735a03813ff946736c2dd455.svg";
export { ForwardRef as ReactComponent };